import { TLanguage } from 'config/tenancy';

export const PHONE_TENANCY_FORMATTERS: Record<
  TLanguage,
  (number: string) => string
> = {
  pt: number => number.replace(/^(\d{2})(\d{4,5})(\d{4}$)/g, '($1) $2-$3'),
  es: number => number.replace(/^(\d{4})(\d{5})/g, '$1 $2'),
  'es-CR': number => number.replace(/^(\d{4})(\d{4})/g, '$1 $2'),
  'es-UY': number => number.replace(/^(\d{4})(\d{4})/g, '$1 $2'),
};
